<div class="modal-backdrop">
    <div id="bedcspacingwarning">
        <div id="modal-header" class="modal-warning"></div>

        <div class="modal-content text-center padding-20px">
            <h5><strong>{{title}}</strong></h5>
            <br>
            <p class="modal-paragraph font-size-2" [innerHtml]="cmsModel.ModifyDCProcessErrors"></p>
            <div class="text-center padding-top-10px">
                <input type="button" class="btn btn-default blackButton margin-right-20px" value="CONTINUE"
                    (click)="goToDcLanding()" />
            </div>
        </div>
    </div>
</div>